import React from 'react';
import BaristaBot from '../img/barista-bot.svg';
import GreatTeam from '../img/great-team.svg';
import FooterCopy from './FooterCopy';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-bot">
          <img src={GreatTeam} alt="Bot" className="footer-bot" />
        </div>
      </div>
      <img src={BaristaBot} alt="Barista Bot" className="footer-baristabot" />
      <div className="social-media-buttons">
        <a href="https://instagram.com/baristabot_app" target="_blank" rel="noopener noreferrer" className="social-button instagram">Instagram  ↗</a>
        <a href="https://x.com/baristabot_app" target="_blank" rel="noopener noreferrer" className="social-button twitter">Twitter/X  ↗</a>
        <a href="https://notes.baristabot.app" target="_blank" rel="noopener noreferrer" className="social-button substack">Substack  ↗</a>
      </div>
      <div className="footer-copy">
        <FooterCopy />
      </div>
    </footer>
  );
};

export default Footer;
